import { render } from "./dropdownHotspot.vue?vue&type=template&id=b5ac15c6"
import script from "./dropdownHotspot.vue?vue&type=script&lang=js"
export * from "./dropdownHotspot.vue?vue&type=script&lang=js"

import "./dropdownHotspot.vue?vue&type=style&index=0&id=b5ac15c6&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__